import React, { useState } from 'react';
import cn from 'classnames';
import Button from 'components/Button';
import PropTypes from 'prop-types';
import { MODAL } from 'constants';
import { i18n } from 'utils/i18n';
import RecommendedExtraDetailsModal from 'components/modals/RecommendedExtraDetailsModal';
import PrintRecommendedAlertBanner from './PrintRecommendedAlertBanner';
/**
 * RecommendedAlertHeader component shows the recommended policies in a banner on the extras page
 * this banner also contains a list of remaining recommended extras.
 * This component is not present if all recommended extras are already included in the bundle
 *
 * @param {object}    props - React Props
 * @param {string}    props.countryCode - the pick up country code, used for getting the correct i18n key for banner text
 * @param {array}     props.recommendedExtras - array of recommended extras
 * @param {function}  props.openModal - opens a modal
 * @return {JSX}      RecommendedAlertHeader component
 */

const RecommendedAlertHeader = ({ countryCode, recommendedExtras, openModal, scrollToRef }) => {
  const [recommendedDetailedDescription, setRecommendedDetailedDescription] = useState('');
  const [recommendedDetailLabel, setRecommendedDetailLabel] = useState('');

  const handleDetailsClick = (label, detailedDescription) => () => {
    setRecommendedDetailedDescription(detailedDescription);
    setRecommendedDetailLabel(label);
    openModal(MODAL.RECOMMENDED_EXTRA_DETAILS_MODAL);
  };

  const printRecommendedCoverage = () =>
    recommendedExtras.map(({ code, name, detailed_description, selected_quantity }) => {
      const individualCoverageClassNames = cn('recommended-alert-header__individual-coverage', {
        'recommended-alert-header__individual-coverage--added': selected_quantity > 0,
      });
      return (
        <div key={code} className={individualCoverageClassNames}>
          <PrintRecommendedAlertBanner code={code} name={name} printRecommendedCoverage />
          <Button linkText onClick={handleDetailsClick(name, detailed_description)}>
            {i18n('recommended_alert_header_more_info_button_texts')}
          </Button>
        </div>
      );
    });

  return (
    <div className='recommended-alert-header__container'>
      <h4 className='recommended-alert-header__title'>{i18n('recommended_alert_header_title')}</h4>
      <PrintRecommendedAlertBanner countryCode={countryCode} scrollToRef={scrollToRef} printAddOnBanner />

      {printRecommendedCoverage()}
      <RecommendedExtraDetailsModal
        recommendedDetailLabel={recommendedDetailLabel}
        recommendedDetailedDescription={recommendedDetailedDescription}
      />
    </div>
  );
};

RecommendedAlertHeader.propTypes = {
  countryCode: PropTypes.string,
  recommendedExtras: PropTypes.array,
  openModal: PropTypes.func,
  scrollToRef: PropTypes.func,
};

export default RecommendedAlertHeader;
